<iframe class="page" src="https://blog.sugoitoolkit.com/" title="W3Schools Free Online Web Tutorials"></iframe>

<style>
    .page {
        width: 100vw;
        height: 100vh;
    }
</style>